var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f-info',{staticClass:"debt-limit-f-info",attrs:{"window-closeable":"","window-class":"light"}},[_vm._v(" If your debt reaches 100% of your Debt Limit, your collateral will be liquidated. This percentage increases when your collateral value falls, or when you borrow more. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }